<script>
  import Modal from './Modal.svelte';
  import LegendCell from './LegendCell.svelte';
  import CharacterPopup from './CharacterPopup.svelte';
  import Event from './Event.svelte';
  import { fade } from 'svelte/transition';

  export let relationship = {};

  let modal = {};
  const handleEventModal = (event) => {
    modal = {
      component: Event,
      event,
    };
  }
  const handleCharacterModal = (character) => {
    modal = {
      component: CharacterPopup,
      character,
    };
  }
</script>

<style>
  .section-label {
    margin-top: 0;
  }
  .characters {
    margin-bottom: 1em;
  }
  .characters figure {
    margin: 0;
  }
  .characters figcaption {
    padding-top: .5em;
    text-align: center;
  }
  .character {
    display: inline-block;
  }
  .character img {
    height: 100px;
    display: block;
    margin: 0 auto;
  }
  .character:not(:last-child) {
    margin-right: 1em;
  }
  button.character {
    padding: 0;
  }
  .relationship {
    padding-bottom: 2rem;
  }
  .content {
    margin-bottom: 1rem;
    overflow: hidden;
  }
  .content :global(.legend-item) {
    margin-bottom: 0;
  }
  .content :global(p) {
    margin-top: 0;
  }
  .events button {
    display: block;
  }

  @media (min-width: 1024px) {
    .relationship {
      border-top: 1px dashed #9D9D9D;
      margin-top: 2rem;
      padding-top: 2rem;
    }
  }
</style>

{#if 'characters' in relationship && relationship.characters.length == 2}
<div class="relationship" in:fade>
  <div>
    <div class="section-label">Actors</div>
    <div class="characters">
      {#each relationship.characters as character}
        <button class="character" on:click={handleCharacterModal(character)}>
          <figure>
            <div class="bordered-image">
              <img src="{character.imgs[0]}" alt="Image of {character.name}"/>
            </div>
            <figcaption class="label">{character.name}</figcaption>
          </figure>
        </button>
      {/each}
    </div>
    {#if 'notes' in relationship && relationship.notes}
    <div class="section-label">Relationship</div>
    <div class="content">
      <div style="float: left;">
        <LegendCell relationship={relationship.status} variant="big hide-label"/>
      </div>
      {@html relationship.notes}
    </div>
    {/if}

    {#if 'events' in relationship && relationship.events.length}
      <div class="events">
        <div class="section-label">Select Events</div>
        {#each relationship.events as e}
          <button class="button" on:click={handleEventModal(e)}>{e.name}</button>
        {/each}
      </div>
    {/if}
  </div>
</div>
{/if}

{#if 'component' in modal}
<Modal on:close="{() => modal = {}}">
  <slot>
    <svelte:component this={modal.component} {...modal}/>
  </slot>
</Modal>
{/if}